import React from "react";
import PropTypes from "prop-types";
import SearchForm from "../../dataentry/lib/search/views/SearchForm";
import Select from "lib/common/controls/Select";
import Integer from "lib/common/controls/Integer";
import Button from "lib/common/descriptorcontrols/BaseControls/Button";
import { useMembersForStereotype } from "data/selectors/aggregateMembers";

function useSanitizeSelectionEffect(
    allItems,
    selected,
    updateCallback,
    extractKey = it => it.key,
) {
    React.useEffect(
        () => {
            if (!allItems) return;
            if (selected.length === 0) {
                updateCallback([extractKey(allItems[0])]);
                return;
            }
            const known = new Set(allItems
                .map(extractKey));
            const next = selected
                .filter(it => known.has(it));
            if (selected.length !== next) {
                updateCallback(next);
            }
        },
        [allItems, selected],
    );
}

export function DataQualityFormLayout(props) {
    const {
        searchByOnCommitChange,
        searchByOptions,
        searchByValue,

        reportTypeOnCommitChange,
        reportTypeValue,
        reportTypeOptions,

        validationTypeOnCommitChange,
        validationTypeValue,
        validationTypeOptions,

        ownersOnCommitChange,
        ownersValue,

        pageSizeOnCommitChange,
        pageSizeValue,

        fluxContext,
        onSubmit,
        onExport,

    } = props;

    const rawMembers = useMembersForStereotype(searchByValue);
    const members = React.useMemo(() => {
        if (!rawMembers) return null;
        return [{name: "All", key: ""}]
            .concat(rawMembers);
    }, [rawMembers]);
    useSanitizeSelectionEffect(members, ownersValue, ownersOnCommitChange);

    return <React.Fragment>
        <div className="row">
            <div className="col-md-12">
                <h2>Data Quality Report</h2>
            </div>
        </div>
        <div className="form-container">
            <div className="row">
                <div id="dqr-report-options" className="col-md-3">
                    {searchByOptions.length > 1 && <Select
                        id="stereotype"
                        options={searchByOptions}
                        onCommitChange={searchByOnCommitChange}
                        value={searchByValue}
                        label="Search By"
                    />}
                    <Select
                        id="reporttype"
                        options={reportTypeOptions}
                        onCommitChange={reportTypeOnCommitChange}
                        value={reportTypeValue}
                        label="Report Type"
                    />
                    <Select
                        id="validationtype"
                        options={validationTypeOptions}
                        onCommitChange={validationTypeOnCommitChange}
                        value={validationTypeValue}
                        label="Report Type"
                        disabled={reportTypeValue === "a"}
                    />
                    {members && <React.Fragment>
                        <label>Data Owners</label>
                        <Select
                            id="owner"
                            value={ownersValue}
                            onCommitChange={ownersOnCommitChange}
                            options={members}
                            labelKey={"name"}
                            valueKey={"key"}
                            multiple
                            size={Math.min(members.length, 8)}
                            disabled={members.length < 3}
                        />
                    </React.Fragment>}
                    <label>Page Size</label>
                    <Integer
                        id="pagesize"
                        onCommitChange={pageSizeOnCommitChange}
                        value={pageSizeValue}
                        label="Page Size"
                    />
                </div>
                <div id="dqr-search-form" className="col-md-6">
                    <SearchForm
                        fluxContext={fluxContext}
                        showAdvanced={true}
                        supportsRelativeDates
                        onSubmit={onSubmit}
                    />
                </div>
            </div>
        </div>
        <div id="v-actions" className="form-row">
            <div className="form-actions">
                <button className="btn btn-search" type="submit"
                        onClick={onSubmit}>
                    <span /> Search
                </button>
                {" "}
                <Button
                    enabled={true}
                    label={"Export"}
                    options={[
                        {value: "xls", label: "Excel (XLS)"},
                    ]}
                    className={"btn btn-export export-button"}
                    collapse={false}
                    onClick={(e, d, v) => onExport(e, v.value)}
                />
            </div>
        </div>
    </React.Fragment>;
}

DataQualityFormLayout.propTypes = {
    searchByOnCommitChange: PropTypes.func.isRequired,
    searchByValue: PropTypes.string.isRequired,
    searchByOptions: PropTypes.array.isRequired,

    reportTypeOnCommitChange: PropTypes.func.isRequired,
    reportTypeValue: PropTypes.string.isRequired,
    reportTypeOptions: PropTypes.array.isRequired,

    validationTypeOnCommitChange: PropTypes.func.isRequired,
    validationTypeValue: PropTypes.string.isRequired,
    validationTypeOptions: PropTypes.array.isRequired,

    ownersOnCommitChange: PropTypes.func.isRequired,
    ownersValue: PropTypes.arrayOf(PropTypes.string),

    pageSizeOnCommitChange: PropTypes.func.isRequired,
    pageSizeValue: PropTypes.number.isRequired,

    fluxContext: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onExport: PropTypes.func.isRequired,
};

export default DataQualityFormLayout;



// WEBPACK FOOTER //
// ./app/lib/dqr/views/DataQualityFormLayout.js